import { ApiBase } from '@bymason/api-base';
import { CmsSelectDeviceToBuildView } from './types';

export * from './types';

class SelectDeviceToBuildViewCmsApi extends ApiBase {
  private static instance: SelectDeviceToBuildViewCmsApi;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A SelectDeviceToBuildViewCmsApi instance
   */
  public static getInstance(): SelectDeviceToBuildViewCmsApi {
    if (!SelectDeviceToBuildViewCmsApi.instance) {
      SelectDeviceToBuildViewCmsApi.instance = new SelectDeviceToBuildViewCmsApi();
    }

    return SelectDeviceToBuildViewCmsApi.instance;
  }

  /**
   * Gets CMS content specific to the Select-Device-To-Build view.
   * @returns either a CmsSelectDeviceToBuild model or void
   */
  public async getViewContent() {
    //
    // TODO: Setup endpoint calls to get content from Strapi CMS
    //
    const dataResponse = await Promise.resolve<CmsSelectDeviceToBuildView>({
      heroHeading: 'Select a <strong>Mason</strong> device to start building your smart mobile product',
      heroSubheading:
        'Mason provides mobile infrastructure across hardware, software, logistics, and support for developing and delivering dedicated devices. Browse our devices, build your custom mobile experience, and take your idea to market in days — not years.',
      cta: {
        caption: 'Select a Device',
        subcaption: '',
      },
      helpTopic: 'select-device-to-build',
    });

    return dataResponse;
  }
}

export const selectDeviceToBuildViewCmsApi = SelectDeviceToBuildViewCmsApi.getInstance();
